import { hooks } from "./hookactions"
export let QUTOfferingDetails = { hooks }
